/* ===================================================================
   KAAYU - SAME-STORE LINK NORMALISER
   Loaded from layout/theme.liquid.

   WHY THIS EXISTS
   Several links point at the store by its full public address rather than by
   path - https://www.kaayurituals.com/pages/concerns instead of
   /pages/concerns. The ones written into theme files have been corrected, but
   the main navigation is not a theme file: menu items live in Shopify admin
   under Content > Menus, and whoever built the menu pasted full URLs. Liquid
   renders whatever the menu holds, so no template change can reach them.

   The effect is that a visitor on the dev server or on a preview theme clicks
   "Concerns" and is thrown out to the live storefront, losing the theme they
   were looking at. That makes a preview theme impossible to review properly.

   WHAT THIS DOES
   Rewrites any link that points at this store by absolute address into the
   equivalent path, so it stays on whatever host is serving the page. On the
   live site the result is identical - /pages/concerns and
   https://www.kaayurituals.com/pages/concerns resolve to the same place - so
   this is inert in production and only matters off it.

   It deliberately leaves alone: other domains, mailto:, tel:, anchors, and
   anything with a download attribute.

   THIS IS A SAFETY NET, NOT THE FIX. The permanent correction is to edit those
   menu items in Shopify admin to use relative paths. Once that is done this
   file can go.
   =================================================================== */
(function () {
  'use strict';

  // the store's own public hostnames, with and without www
  var HOSTS = ['www.kaayurituals.com', 'kaayurituals.com'];

  function normalise(root) {
    var links = (root || document).querySelectorAll('a[href]');
    var fixed = 0;

    Array.prototype.forEach.call(links, function (a) {
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '/' || href.charAt(0) === '#') return;
      if (/^(mailto:|tel:|javascript:)/i.test(href)) return;

      var url;
      try {
        url = new URL(href, window.location.href);
      } catch (e) {
        return;
      }
      if (HOSTS.indexOf(url.hostname) === -1) return;

      // already on the live site: nothing to gain, and rewriting would only
      // add churn to a page that is working correctly
      if (HOSTS.indexOf(window.location.hostname) !== -1) return;

      a.setAttribute('href', url.pathname + url.search + url.hash);

      // an internal link that opens a new tab was almost certainly a side
      // effect of it having been written as an external URL
      if (a.getAttribute('target') === '_blank' && !a.hasAttribute('download')) {
        a.removeAttribute('target');
        a.removeAttribute('rel');
      }
      fixed++;
    });

    return fixed;
  }

  function run() {
    normalise(document);

    // menus and drawers are often rendered after load, so watch for new links
    if ('MutationObserver' in window) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          normalise(document);
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
